import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, map, of } from 'rxjs'
import { Backend } from 'src/app/shared/enums/enums'
import { DdcLoggerService } from '../log/ddc-logger.service'

@Injectable({
  providedIn: 'root',
})
export class BookmarkService {
  constructor(
    private http: HttpClient,
    private logger: DdcLoggerService,
  ) {}

  bookmark(
    bookmark: boolean,
    content_type_id: number,
    object_id: number,
    group_id: number = null,
  ): any {
    this.logger.info('BookmarkService | bookmark | bookmark: ' + bookmark)
    this.logger.info('BookmarkService | bookmark | content_type_id: ' + content_type_id)
    this.logger.info('BookmarkService | bookmark | object_id: ' + object_id)
    this.logger.info('BookmarkService | bookmark | group_id: ' + group_id)
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    const data = {
      bookmark: bookmark,
      content_type_id: content_type_id,
      object_id: object_id,
      group_id: group_id,
    }

    return this.http.post(`${Backend.HOST_CONTAINER + Backend.BOOKMARKS}`, data, httpOptions).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: any) => {
        const errorMessage = error.error
        this.logger.error('BookmarkService | bookmark | catchError | errorMessage: ' + errorMessage)
        return of({ success: false, res: errorMessage })
      }),
    )
  }

  add_bookmark_group(name: string): any {
    this.logger.info('BookmarkService | add_bookmark_group | name: ' + name)
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    const data = {
      name: name,
    }

    return this.http
      .post(`${Backend.HOST_CONTAINER + Backend.BOOKMARK_GROUPS}`, data, httpOptions)
      .pipe(
        map((res: any) => {
          return res
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error(
            'BookmarkService | add_bookmark_group | catchError | errorMessage: ' + errorMessage,
          )
          return of({ success: false, res: errorMessage })
        }),
      )
  }

  get_bookmark_groups_page(page: number, pageSize: number): any {
    this.logger.info('BookmarkService | get_bookmark_groups_page | page: ' + page)
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http
      .get(
        `${Backend.HOST_CONTAINER + Backend.BOOKMARK_GROUPS}?page=${page}&pageSize=${pageSize}`,
        httpOptions,
      )
      .pipe(
        map((res: any) => {
          return res
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error(
            'BookmarkService | get_bookmark_groups_page | catchError | errorMessage: ' +
              errorMessage,
          )
          return of(errorMessage)
        }),
      )
  }

  get_bookmark_groups(): any {
    this.logger.info('BookmarkService | get_bookmark_groups')
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http
      .get(`${Backend.HOST_CONTAINER + Backend.BOOKMARK_GROUPS}?no_page=true`, httpOptions)
      .pipe(
        map((res: any) => {
          return res
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error(
            'BookmarkService | get_bookmark_groups | catchError | errorMessage: ' + errorMessage,
          )
          return of(errorMessage)
        }),
      )
  }

  get_bookmark_group(id: number): any {
    this.logger.info('BookmarkService | get_bookmark_group | id: ' + id)
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http
      .get(`${Backend.HOST_CONTAINER + Backend.BOOKMARK_GROUPS}${id}/?no_page=true`, httpOptions)
      .pipe(
        map((res: any) => {
          return res
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error(
            'BookmarkService | get_bookmark_group | catchError | errorMessage: ' + errorMessage,
          )
          return of(errorMessage)
        }),
      )
  }

  get_collection_items_page(page: number, pageSize: number, collection_id: number = null): any {
    this.logger.info('BookmarkService | get_collection_items_page | page: ' + page)
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    let url = ''
    if (!collection_id)
      url = `${Backend.HOST_CONTAINER + Backend.COLLECTIONS + Backend.ALL_COLLS}?page=${page}`
    else
      url = `${Backend.HOST_CONTAINER + Backend.COLLECTIONS + Backend.COLL_ITEMS}?page=${page}&id=${collection_id}`

    return this.http.get(`${url}`, httpOptions).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: any) => {
        const errorMessage = error.error
        this.logger.error(
          'BookmarkService | get_collection_items_page | catchError | errorMessage: ' +
            errorMessage,
        )
        return of(errorMessage)
      }),
    )
  }

  edit_collection(coll_data: any): any {
    this.logger.info('BookmarkService | edit_collection | coll_data: ', coll_data)
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http
      .patch(
        `${Backend.HOST_CONTAINER + Backend.BOOKMARK_GROUPS + coll_data.id + '/'}`,
        coll_data,
        httpOptions,
      )
      .pipe(
        map((res: any) => {
          return { success: true, res: res }
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error(
            'BookmarkService | edit_collection | catchError | errorMessage: ' + errorMessage,
          )
          return of({ success: false, res: errorMessage })
        }),
      )
  }

  delete_collection(coll_id: number): any {
    this.logger.info('BookmarkService | edit_collection | coll_data: ', coll_id)
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http
      .delete(`${Backend.HOST_CONTAINER + Backend.BOOKMARK_GROUPS + coll_id + '/'}`, httpOptions)
      .pipe(
        map((res: any) => {
          return { success: true, res: res }
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error(
            'BookmarkService | delete_collection | catchError | errorMessage: ' + errorMessage,
          )
          return of({ success: false, res: errorMessage })
        }),
      )
  }
}
